
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sexleketoy/pegging",
      function () {
        return require("private-next-pages/sexleketoy/pegging/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sexleketoy/pegging"])
      });
    }
  